// extracted by mini-css-extract-plugin
module.exports = {"shadowBtn":"_X_Dd","widgetWrap":"Cym4g","widgetContent":"aPi3p"};